import React, { Component } from 'react'
import { Card, Button } from 'hljd'
import { inject, observer } from 'mobx-react'
import TimeInput from './TimeInput'
import CompareData from './CompareData'
import QRModal from './QRModal'
import Style from './style.module.less'
import { VIDEO_REVIEW, VIDEO_COMING, VIDEO_IN_AUDIT } from '../constant'

@inject('store')
@observer
export default class extends Component {
  render() {
    const {
      store: {
        isPreview,
        changeQrModalVisable,
        liveStatus,
        setVideoRef,
        detail = {},
        videoNetStatus
      }
    } = this.props
    const { fname } = detail.playback || {}
    return (
      <Card
        title="直播预览"
        bordered={0}
        extra={
          isPreview && (
            <Button onClick={changeQrModalVisable}>移动端直播预览</Button>
          )
        }
      >
        <div className={Style.video} ref={setVideoRef}>
          {(liveStatus == VIDEO_IN_AUDIT || liveStatus == VIDEO_COMING) && (
            <div className={Style['video-desc']}>直播未开始</div>
          )}
          {liveStatus == VIDEO_REVIEW &&
            !fname && (
              <div className={Style['video-desc']}>直播生成中，请稍后...</div>
            )}

          {/* 网络很差 */}
          {videoNetStatus == '2' ? (
            <div
              className={`${Style['video-net-status']} ${Style['slower-net']}`}
            >
              <img
                src="https://qnm.hunliji.com/o_1dn4gui3lc1c1tpn1i4911s31nr19.png"
                alt=""
              />
              <span>网络很差</span>
              <p>建议使用WIFI、联通4G或者更换直播场地</p>
            </div>
          ) : null}

          {/* 网络不好 */}
          {videoNetStatus == '1' ? (
            <div
              className={`${Style['video-net-status']} ${Style['slow-net']}`}
            >
              <img
                src="https://qnm.hunliji.com/o_1dn4gvj3n8if1cp0ouoel2149me.png"
                alt=""
              />
              <span>网络不好</span>
              <p>建议检查网络连接</p>
            </div>
          ) : null}

          {/* 网络良好 */}
          {videoNetStatus == '0' ? (
            <div
              className={`${Style['video-net-status']} ${Style['normal-net']}`}
            >
              <img
                src="https://qnm.hunliji.com/o_1dn4h15c51alq79g1mpv1odpimhj.png"
                alt=""
              />
              <span>网络良好</span>
            </div>
          ) : null}
        </div>
        {/* 直播结束显示视频裁剪&数据对比 */}
        {liveStatus == VIDEO_REVIEW && <TimeInput />}
        {liveStatus == VIDEO_REVIEW && <CompareData />}
        <QRModal />
      </Card>
    )
  }
}
